export function getMajorMinorAgreementVersion(userLegalAgreementVersion) {
  const [
    policy_major_version = '0',
    policy_minor_version = '0',
  ] = userLegalAgreementVersion.split('.')

  return { policy_major_version, policy_minor_version }
}
